import { render, staticRenderFns } from "./SetApplicationColor.vue?vue&type=template&id=379fcc10&"
import script from "./SetApplicationColor.vue?vue&type=script&lang=js&"
export * from "./SetApplicationColor.vue?vue&type=script&lang=js&"
import style0 from "./SetApplicationColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports